import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
    UsersIcon,
    ChatBubbleLeftRightIcon,
    ChartBarIcon,
    Cog6ToothIcon,
    PresentationChartLineIcon,
    BeakerIcon
} from '@heroicons/react/24/outline';
import UsersManagement from './UsersManagement';
import ChatAnalytics from './ChatAnalytics';
import Reports from './Reports';
import Settings from './Settings';
import UserAnalytics from './UserAnalytics';
import ExplorerResponses from './ExplorerResponses';

const AdminDashboard = () => {
    const [activeTab, setActiveTab] = useState('users');

    const tabs = [
        {
            id: 'users',
            name: 'Users',
            icon: UsersIcon,
            color: 'blue',
            component: UsersManagement
        },
        {
            id: 'insights',
            name: 'User Insights',
            icon: PresentationChartLineIcon,
            color: 'indigo',
            component: UserAnalytics
        },
        { 
            id: 'analytics', 
            name: 'Analytics', 
            icon: ChatBubbleLeftRightIcon, 
            color: 'green',
            component: ChatAnalytics
        },
        {
            id: 'reports',
            name: 'Reports',
            icon: ChartBarIcon,
            color: 'purple',
            component: Reports
        },
        {
            id: 'explorer',
            name: 'Explorer Responses',
            icon: BeakerIcon,
            color: 'amber',
            component: ExplorerResponses
        },
        { 
            id: 'settings', 
            name: 'Settings', 
            icon: Cog6ToothIcon, 
            color: 'gray',
            component: Settings
        },
    ];

    const ActiveComponent = tabs.find(t => t.id === activeTab)?.component || UsersManagement;

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header with Tabs */}
            <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="py-6">
                        <motion.h1 
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            className="text-3xl font-bold text-gray-900"
                        >
                            Admin Dashboard
                        </motion.h1>
                    </div>

                    {/* Tabs */}
                    <div className='container'>
                    <div className="flex space-x-8 overflow-x-auto pb-1">
                        {tabs.map((tab) => (
                            <motion.button
                                key={tab.id}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                onClick={() => setActiveTab(tab.id)}
                                className={`relative flex items-center px-3 py-4 text-sm font-medium transition-colors border-b-2 ${
                                    activeTab === tab.id
                                        ? `border-${tab.color}-500 text-${tab.color}-600`
                                        : 'border-transparent text-gray-500 hover:text-gray-700'
                                }`}
                            >
                                <tab.icon className={`h-5 w-5 mr-2 ${
                                    activeTab === tab.id ? `text-${tab.color}-600` : 'text-gray-400'
                                }`} />
                                {tab.name}
                            </motion.button>
                        ))}
                    </div>
                    </div>
                </div>
            </div>

            {/* Content Area */}
            <motion.div
                key={activeTab}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
            >
                <ActiveComponent />
            </motion.div>
        </div>
    );
};

export default AdminDashboard;